import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";

import "./styles.scss";

const FormRow = ({ label, className, children }) => {
  return (
    <Form.Group as={Row} className={classNames("form-group-row", className)}>
      <Form.Label column sm="4">
        {label}
      </Form.Label>
      <Col sm="8">{children}</Col>
    </Form.Group>
  );
};

FormRow.defaultProps = {
  required: false,
};

FormRow.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default FormRow;
